import Component, { Topic } from 'component';
customElements.define('x-shopify-account', class extends Component {
    constructor() {
        super();
    }
    onMobile() {
        this.sub(Topic.NEWSLETTER_POPUP_OPENED, this.refreshLayer, { global: true, once: true });
    }
    refreshLayer() {
        const dialog = this.querySelector('shopify-account').shadowRoot.querySelector('dialog');
        if (dialog.hasAttribute('open')) {
            dialog.style.animation = 'none';
            dialog.close();
            dialog.showModal();
        }
    }
});
